import { render } from "./TutorReportChart.vue?vue&type=template&id=25164c22&scoped=true"
import script from "./TutorReportChart.vue?vue&type=script&lang=js"
export * from "./TutorReportChart.vue?vue&type=script&lang=js"

import "./TutorReportChart.vue?vue&type=style&index=0&id=25164c22&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25164c22"]])

export default __exports__